export const LOCALE_SELECTED = 'LOCALE_SELECTED';

export const selectedLocale = locale => async (dispatch, getState) => {
  dispatch({ type: LOCALE_SELECTED, locale: locale });
};
